<!-- FIXME: inline style についてはデザインを当てる際に修正する -->
<template>
  <div class="received-log">
    <div class="feedback">
      <transition name="fade" @enter="enterErrorFeedback">
        <feedback-error v-if="showableErrorFeedback" :message="errorMessage" />
      </transition>
    </div>
    <PageHeadline title="受け取りログ" />
    <div v-if="isLoadingLogs" class="received-log__loading">
      <loading />
    </div>
    <div v-else-if="!isEmptyResult">
      <received-log-box
        v-for="receivedLog in receivedLogs"
        :id="receivedLog.id"
        :key="receivedLog.id"
        :sender-name="receivedLog.senderName"
        :sender-icon-image-url="receivedLog.senderIconImageUrl"
        :message="receivedLog.message"
        :received-at="receivedLog.receivedAt"
        :card-design-image-url="receivedLog.cardDesignImageUrl"
        :token="receivedLog.token"
      />
      <Pagination
        :current-page="currentPage"
        :total-pages="totalPages"
        @clicked="changePage"
      />
      <div class="received-log__to-giftee-top-area">
        <a href="/" class="received-log__to-giftee-top-link text-link-to-top">
          gifteeトップへ戻る
        </a>
      </div>
      <div class="received-log__to-top-area">
        <span class="received-log__to-top-link subhead" @click="scrollToTop">
          ページトップへ ▲
        </span>
      </div>
    </div>
    <div v-else>
      <div class="received-log__gray-border"></div>
      <div class="received-log__empty-results">
        <p class="received-log__empty-result-message">
          受け取ったギフトカードを保存すると
        </p>
        <p class="received-log__empty-result-message">
          ここに表示されます
        </p>
      </div>
      <div class="received-log__to-giftee-top-area">
        <a href="/" class="received-log__to-giftee-top-link text-link-to-top">
          gifteeトップへ戻る
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from '../../atoms/loadings/Loading'
import ReceivedLogBox from '../../organism/mypages/received_logs/ReceivedLogBox'
import Pagination from '../../organism/paginations/Pagination'
import FeedbackError from '../../atoms/feedbacks/feedback-error'
import PageHeadline from '../../molecules/headlines/PageHeadline'
import defaultIconImage from '../../../../../images/styleguide/none.png'
import axios from 'axios'
import url from 'url'
import qs from 'qs'

export default {
  components: {
    Loading,
    ReceivedLogBox,
    Pagination,
    FeedbackError,
    PageHeadline
  },
  data() {
    return {
      receivedLogs: [],
      isLoadingLogs: false,
      showPageCounts: [],
      page: 1,
      showableErrorFeedback: false,
      errorMessage: '',
      currentPage: 1,
      totalPages: 0,
      isLoading: false
    }
  },
  computed: {
    isEmptyResult() {
      return this.receivedLogs.length === 0
    }
  },
  mounted() {
    this.initializeParams()
    this.getPurchaseHistories(this.currentPage)

    // NOTE: ブラウザバック・フォワード時の更新処理
    window.onpopstate = async function() {
      this.initializeParams()
      this.getPurchaseHistories(this.currentPage)
    }.bind(this)
  },
  methods: {
    initializeParams() {
      const urlQuery = url.parse(location.href).query
      if (!urlQuery) {
        this.currentPage = 1
        return
      }
      const parsed = qs.parse(urlQuery)
      this.currentPage = parsed.page ? Number(parsed.page) : 1
    },
    updateUrlFromParams() {
      history.pushState(
        '',
        '',
        this.currentPage <= 1
          ? '/mypage/received_logs'
          : `/mypage/received_logs?page=${this.currentPage}`
      )
    },
    async getPurchaseHistories(page) {
      this.isLoadingLogs = true

      try {
        const res = await axios.get(
          `/api/v1/users/@me/received_logs?page=${page || 1}&limit=10`
        )
        if (res.data.length === 0) {
          this.isLoadingLogs = false
          return
        }
        const { current_page, total_pages } = res.data.meta
        this.currentPage = current_page
        this.totalPages = total_pages
        this.receivedLogs = res.data.data.map(receivedLog => {
          const senderIconImageUrl =
            receivedLog.attributes.sender_icon_image_url !== null
              ? receivedLog.attributes.sender_icon_image_url
              : defaultIconImage

          const message =
            receivedLog.attributes.message || 'メッセージはありません'

          return {
            id: receivedLog.attributes.id,
            message: message,
            senderName: receivedLog.attributes.sender_name,
            senderIconImageUrl: senderIconImageUrl,
            receivedAt: receivedLog.attributes.received_at,
            cardDesignImageUrl: receivedLog.attributes.card_design_image_url,
            token: receivedLog.attributes.token
          }
        })
        this.isLoadingLogs = false
      } catch (error) {
        this.isLoadingLogs = false
        this.showableErrorFeedback = true
        this.errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
      }
    },
    async changePage(page) {
      await this.getPurchaseHistories(page)
      this.updateUrlFromParams()
      this.scrollToTop()
    },
    scrollToTop() {
      window.scrollTo({ top, behavior: 'smooth' })
    },
    enterErrorFeedback() {
      setTimeout(() => {
        this.showableErrorFeedback = false
      }, 3000)
    }
  }
}
</script>
